import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { makeStyles } from '@material-ui/core/styles';
import useUserInfo from '../../auth/useUserInfo';
import { RecipientRole } from '../../common/recipients/types';
import RecipientManagement from '../../containers/recipient-management/recipient-management';
import { useDispatch, useShallowSelector } from '../../lib/reduxHooks';

import * as actions from '../../store/senderBuild/actions';

const useStyles = makeStyles(() => ({
  root: {
    padding: '0',
    '&:first-child': {
      paddingTop: '0',
    },
  },
  paper: {
    maxWidth: '880px',
    maxHeight: '600px',
    height: '100%',
    width: '100%',
  },
  dialogActionsRoot: {
    borderTop: '1px solid #CAD5E0',
    padding: '14px 24px',
  },
  closeButton: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

interface IProps {
  open: boolean;
  toggleModal: () => void;
}
// eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
export const RecipientsModal = (props: IProps) => {
  const { recipientsModal, id } = useShallowSelector((state) => ({
    recipientsModal: state.senderBuild.recipientsModal,
    id: state.senderBuild.id,
  }));

  const userInfo = useUserInfo();
  const { open, toggleModal } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { recipients, loading } = recipientsModal;
  // eslint-disable-next-line func-style -- This code was written prior to enforcing lint rules
  const handleSave = () => {
    dispatch(actions.updateRecipients(recipients, id ?? '', userInfo!));
  };
  const saveDisabled = loading || !recipients.length || !recipients.some((r) => r.role === RecipientRole.Signer);

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} onClose={toggleModal}>
      <DialogContent classes={{ root: classes.root }}>
        <RecipientManagement modal />
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogActionsRoot }}>
        <Button color="primary" disabled={loading} onClick={toggleModal} style={{ marginRight: '12px' }}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saveDisabled}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};
// eslint-disable-next-line import/no-default-export -- This code was written prior to enforcing lint rules
export default RecipientsModal;
